export const AUTO_RESTART_SECONDS = 60

export const nextCountdownValue = (secondsLeft: number): number =>
  Math.max(0, secondsLeft - 1)
